// import {Configurator, DashboardNavbar, Footer, Sidenav,} from "@/widgets/layout";
import {Card, CardBody, CardHeader, Typography} from "@material-tailwind/react";
import React, {useEffect, useState} from "react";
import {AdminUserAgentsDashboard} from "./admin_users_agents_dashboard";
import {getDashboard} from "../../services/dashboard/dashboard";
import persianNumberFormat from "../../helper/PersianNumberFormat";
import TodayServicesDashboard from "./today_services_dashboard";
import ServicesDashboard from "./services_dashboard";
import {AdminFinance} from "./admin_finance_dashboard";

export function Dashboard() {

  const [adminUsersAgentDashboard, setAdminUsersAgentDashboard] = useState(null)
  const [adminUsersAgentDashboardLoaded, setAdminUsersAgentDashboardLoaded] = useState(false)
  const [todayWorksDashboard, setTodayWorksDashboard] = useState(null)
  const [todayWorksDashboardLoaded, setTodayWorksDashboardLoaded] = useState(false)
  const [worksDashboard, setWorksDashboard] = useState(null)
  const [worksDashboardLoaded, setWorksDashboardLoaded] = useState(false)
  const [financeDashboard, setFinanceDashboard] = useState(null)
  const [financeDashboardLoaded, setFinanceDashboardLoaded] = useState(false)

  const [updatedAt, setUpdatedAt] = useState("")
  const [from, setFrom] = useState("person")

  async function getData() {
    const result = await getDashboard();
    if (result.status === 200) {
      const {
        userAgentDashboardStatistic,
        TodayWorksDashboardStatistic,
        WorksDashboardStatistic,
        FinanceDashboardStatistic,
        roleId,
        updated_at,
      } = result.data;
      if (roleId === 1 || roleId === 5) {
        setAdminUsersAgentDashboard(userAgentDashboardStatistic)
        setFinanceDashboard(FinanceDashboardStatistic)
        setFrom("admin")
      }
      if (roleId === 2) {
        setFrom("agent")
      }
      setTodayWorksDashboard(TodayWorksDashboardStatistic)
      setWorksDashboard(WorksDashboardStatistic)
      const updated_time = persianNumberFormat(`${updated_at.split(" ")[1]}`)
      setUpdatedAt(updated_time)
    }
  }

  useEffect(() => {
    getData()
  }, []);

  useEffect(() => {
    if (adminUsersAgentDashboard) {
      setAdminUsersAgentDashboardLoaded(true)
    }
  }, [adminUsersAgentDashboard]);

  useEffect(() => {
    if (financeDashboard) {
      setFinanceDashboardLoaded(true)
    }
  }, [financeDashboard]);

  useEffect(() => {
    if (todayWorksDashboard) {
      setTodayWorksDashboardLoaded(true)
    }
    if (worksDashboard) {
      setWorksDashboardLoaded(true)
    }
  }, [todayWorksDashboard, worksDashboard]);

  return (
    <div className="w-full gap-y-8">
      <Card className="pt-8 w-full bg-blue-gray-800 ">
        <CardHeader floated={true} shadow={false} className="bg-blue-gray-800">
          <div className="mb-8 flex flex-col items-start justify-between md:flex-row">
            <Typography variant="h2" color="white">داشبورد</Typography>
            <Typography variant="h5" color="white">{`به‌روزرسانی: ${updatedAt}`}</Typography>
          </div>

        </CardHeader>
        <CardBody className="overflow-x-auto w-full">
          {financeDashboardLoaded &&
            <AdminFinance finance={financeDashboard}/>
          }
          {adminUsersAgentDashboardLoaded &&
            <AdminUserAgentsDashboard userAgents={adminUsersAgentDashboard}/>
          }
          {todayWorksDashboardLoaded &&
            <TodayServicesDashboard todayServices={todayWorksDashboard} from={from}/>
          }
          {worksDashboardLoaded &&
            <ServicesDashboard works={worksDashboard} from={from}/>
          }
        </CardBody>
      </Card>
    </div>
  );
}

Dashboard.displayName = "/src/layout/dashboard.jsx";

export default Dashboard;
